import classNames from "classnames";
import {
  BaseSelect,
  Description,
  FloatingCard,
  RawTextInput,
  flexStyles,
  paddingStyles,
  positionStyles,
  textStyles,
  widthStyles,
} from "ui";
import type { ButtonBlockType } from "./ButtonBlock";

interface Props {
  buttonType: ButtonBlockType;
  url: string;
  phone: string;
  email: string;
  onChangeButtonType: (value: ButtonBlockType) => void;
  onChangeUrl: (url: string) => void;
  onChangePhone: (phone: string) => void;
  onChangeEmail: (email: string) => void;
}

export function Editor({
  buttonType,
  onChangeButtonType,
  onChangeUrl,
  onChangePhone,
  onChangeEmail,
  url,
  phone,
  email,
}: Props) {
  return (
    <FloatingCard
      className={classNames(
        positionStyles.zIndex47,
        paddingStyles.p075,
        textStyles.fontPoppins,
        textStyles.neutral600,
        textStyles.weight400,
        widthStyles.min2000,
        flexStyles.vert050,
      )}
    >
      <Description>Button Type</Description>
      <BaseSelect<ButtonBlockType>
        zIndex={148}
        options={[
          { label: "Link", value: "Link" },
          { label: "Email", value: "Email" },
          { label: "Phone", value: "Phone" },
        ]}
        value={buttonType}
        onChange={(value) => {
          value && value.value && onChangeButtonType(value.value);
        }}
      />
      <Description>Destination</Description>
      {buttonType === "Link" && (
        <RawTextInput value={url} onChange={(e) => onChangeUrl(e.target.value)} placeholder="https://example.com" />
      )}
      {buttonType === "Phone" && (
        <RawTextInput value={phone} onChange={(e) => onChangePhone(e.target.value)} placeholder="+1 (555) 123-4567" />
      )}
      {buttonType === "Email" && (
        <RawTextInput value={email} onChange={(e) => onChangeEmail(e.target.value)} placeholder="contact@example.com" />
      )}
    </FloatingCard>
  );
}
